import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState('Processing your authentication...');

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check if this is an email confirmation callback
        const hashParams = new URLSearchParams(location.hash.substring(1));
        const type = hashParams.get('type');
        
        // Get current session regardless of callback type
        const { data, error } = await supabase.auth.getSession();
        
        console.log('Auth callback type:', type);
        console.log('Session data:', data);
        
        if (error) {
          console.error('Auth callback error:', error);
          setMessage('Authentication error. Redirecting to login...');
          setTimeout(() => navigate('/login?error=' + encodeURIComponent(error.message)), 2000);
          return;
        }
        
        if (type === 'signup' || type === 'recovery' || type === 'invite') {
          // This is an email confirmation
          // For email confirmations, the user might not have an active session yet
          setMessage('Email confirmed successfully! Redirecting to login...');
          
          // Clear any existing sessions to force a fresh login
          await supabase.auth.signOut();
          
          // Redirect to login with success message
          setTimeout(() => navigate('/login?message=Email confirmation successful'), 2000);
        } else if (data?.session) {
          // Standard OAuth callback with active session
          setMessage('Authentication successful! Redirecting to dashboard...');
          setTimeout(() => navigate('/dashboard'), 1000);
        } else {
          // No session, redirect to login
          setMessage('Redirecting to login...');
          setTimeout(() => navigate('/login'), 1000);
        }
      } catch (error) {
        console.error('Unexpected error in auth callback:', error);
        setMessage('An unexpected error occurred. Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    handleAuthCallback();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-purple-50/20 to-pink-50/20">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full text-center glass-panel"
           style={{
             background: 'rgba(255, 255, 255, 0.9)',
             backdropFilter: 'blur(10px)',
             border: '1px solid rgba(255, 255, 255, 0.18)',
             boxShadow: '0 8px 32px rgba(138, 43, 226, 0.1)'
           }}>
        <div className="mb-6 text-[#8a2be2]">
          {/* Loading spinner */}
          <svg className="animate-spin h-10 w-10 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
        <h2 className="text-xl font-semibold mb-2">{message}</h2>
      </div>
    </div>
  );
}

export default AuthCallback;